import { useEffect, useRef } from 'react'
export function useInterval(
  callback: (...args: Array<any>) => any,
  delay: number | null | undefined,
) {
  // SLAM-1938: React 19 requires an initial value for useRef, so we pass undefined. This is valid on React 18 and does not change behaviour.
  const savedCallback = useRef<(() => void) | undefined>(undefined)
  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])
  // Set up the interval.
  useEffect(() => {
    function tick() {
      if (savedCallback.current) savedCallback.current()
    }

    if (delay !== null) {
      let id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
  }, [delay])
}
